/**
 * jQuery UI Drag & Drop
 */

var AwesomeDrag = function () {
    'use strict';

    var $ = jQuery; // enable jQuery
    var self = this;
    self.sortableEl = '.connected-sortable';
    self.testimonials_panel = '#panel-testimonials';

    // Pop up testimonials list for Edit Group panel
    self.cloneTestimonials = function () {
        // add class for z-index
        var $clone = $(self.testimonials_panel).clone().removeAttr('id').attr('panel', 'testimonials-clone').addClass('at-transition');
        window.aet_testimonials_clone = aet_testimonials.clone();

        setTimeout(function () {
            $(self.testimonials_panel).fadeOut();
        }, 100);

        var all_testimonials = $clone.find('.testimonials-list li');
        var model_testimonials = model.get('testimonials') || [];

        // Hide testimonials that already exist in group
        $.each(all_testimonials, function () {
            var id = parseInt($(this).attr('testimonial-id'));
            if (AwesomeUtil.find_in_array_of_objects(model_testimonials, 'ID', id)) {
                var model = aet_testimonials_clone.findWhere({id: id});
                $(this, $clone).remove();
                aet_testimonials_clone.remove(model);
            }
        });

        var $push_all_btn = $('<li><button data-action="push-all-testimonials"><span title="Push all">Push all</span></button></li>');
        $clone.find('.panel-heading .panel-actions').prepend($push_all_btn);

        $('.testimonials-list', aet_panel).html($clone);
        self.bind_clone();

        $(document).on('click', '[data-action="remove-testimonial"]', function(){
            var $item = $(this).parents('li[testimonial-id]'),
                id = +$item.attr('testimonial-id'),
                model = aet_testimonials.findWhere({id:id});
            $('#testimonials-list', aet_panel).append($item);
            aet_testimonials_clone.add(model);
            self.updateElements();
        });
    };

    // Bind highlight for drop zone on testimonial hover
    self.bind_clone = function () {
        // Bind highlight for drop zone on testimonial hover
        $(document).on('mouseenter', ".panel-pop-up #testimonials-list", function () {
            $('#group-sortable', aet_panel).addClass('pulsate');
        });
        $(document).on('mouseleave', ".panel-pop-up #testimonials-list", function () {
            $('#group-sortable', aet_panel).removeClass('pulsate');
        });
        $(document).on('click', '[data-action="push-all-testimonials"]', function () {
            aet_testimonials_clone.reset();
            var testimonials = $('ul.testimonials-list > li', aet_panel);
            var testimonials_ids = _.clone(model.get('testimonials_ids'));
            $.each(testimonials, function (index, item) {
                $('#group-sortable', aet_panel).append(item);
                var id = parseInt($(item).attr('testimonial-id'));
                testimonials_ids.push(id);
            });
            model.set('testimonials_ids', testimonials_ids);
        });
        $(document).on('click', '[data-action="remove-all-testimonials"]', function () {
            var testimonials = $('#group-sortable > li', aet_panel);

            $.each(testimonials, function (index, item) {
                $('ul.testimonials-list', aet_panel).append(item);
                var id = parseInt($(item).attr('testimonial-id'));
                var model = aet_testimonials.findWhere({id: id});
                aet_testimonials_clone.add(model);
            });
            model.set('testimonials_ids', []);
        });
    };

    // Init testimonials drag & drop between two panels
    self.initSortable = function () {
        $(self.sortableEl).addClass('sortable-placeholder');
        $('#group-sortable, #testimonials-list').sortable({
            appendTo: 'body',
            zIndex: 99999,
            connectWith: self.sortableEl,
            forcePlaceholderSize: true,
            placeholder: 'sortable-placeholder-inner',
            cursor: 'move',
            cursorAt: {top: 25, left: 25},
            helper: function (event, ui) { // clone testimonial photo to drag
                var img = $(ui).find('.foto').clone();
                var $clone = $('<li class="item"></li>').append(img);
                return $clone;
            },
            create: function (event, ui) {
            },
            start: function (event, ui) {
                $(ui.helper).addClass('pop-up'); // add border to helper element
                $('.a-slide-panel #group-sortable').addClass('drop-highlight'); // highlight drop zone
            },
            stop: function () {
                $('.a-slide-panel #group-sortable').removeClass('drop-highlight'); // stop drop zone highlighting
            },
            update: function (event, ui) {
                $(ui.item).attr('style', ''); // remove pop-up class on drop event to remove border
                var parent = $(ui.item[0].parentElement).attr('id');
                var id = parseInt($(ui.item[0]).attr('testimonial-id'));
                var model = aet_testimonials.findWhere({id:id});

                if(parent == 'group-sortable'){
                    aet_testimonials_clone.remove(model);
                }else if(parent == 'testimonials-list'){
                    aet_testimonials_clone.add(model);
                }

                self.updateElements();
            }
        });
    };

    // on every drag end save employers order and IDs to hidden field
    self.pushTestimonial = function($el, array, object){
        var id = parseInt($el.attr('testimonial-id'));
        var foto = $el.find('img').attr('src');
        var name = $el.find('.name').html();
        var position = $el.find('.position').html();
        var post_excerpt = $el.find('.short_text').html();

        array.push(id);
        object.push({
            ID: id,
            foto: foto,
            post_title: name,
            post_excerpt: post_excerpt,
            position: position
        });
    }

    // on every drag end save testimonials order and IDs to hidden field
    self.updateElements = function () {
        var $testimonials_field = $('#group-testimonials', aet_panel);
        $testimonials_field.val('');
        var testimonials = [];
        var testimonials_ids = [];
        $('#group-sortable li', aet_panel).each(function () {
            self.pushTestimonial($(this), testimonials_ids, testimonials);
        });
        var result = JSON.stringify(testimonials_ids);
        $testimonials_field.val(result);
        model.set('testimonials_ids', testimonials_ids);
        model.set('testimonials', testimonials);
    };

    // destory drag & drop
    self.destroy = function () {
        $(self.testimonials_panel).show();
        $('.panel.panel-pop-up').remove();
        $('.connected-sortable').removeClass('sortable-placeholder');
        $('#testimonials-list').sortable({
            disabled: true
        });
        $('.testimonials-list', aet_panel).html('');
        $('.panel-pop-up #testimonials-list').off();
    };

    // init drag & drop
    self.init = function () {
        self.cloneTestimonials(); // clone testimonials panel and hide testimonials that already exists in group
        self.updateElements();
        self.initSortable();
    };
};